export const ALLOWED_FILE_TYPES_PERFORMANCE_VISUALIZATION = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];
export const ALLOWED_FILE_TYPES_AVATAR_PICTURE = ['image/jpeg', 'image/png', 'image/webp'];
export const ALLOWED_FILE_TYPES_TENANT_LOGO = ['image/png', 'image/jpeg'];
export const ALLOWED_FILE_TYPES_EXTERNAL_MATERIAL_LOGO = ['image/png', 'image/jpeg', 'image/webp', 'image/gif'];
export const ALLOWED_FILE_TYPES_REPORT_COVER_IMAGE = ['image/png', 'image/jpeg', 'image/webp'];

// A photo, scan or PDF of a class list; CSV and text files are read in the browser and sent as text. The browser
// shrinks photos below the limit.
export const ALLOWED_FILE_TYPES_STUDENT_IMPORT = ['image/jpeg', 'image/png', 'image/webp', 'application/pdf'];
